// Buyer Registration Translations

export const BUYER_TRANSLATIONS = {
  en: {
    pageTitle: 'Buyer Registration',
    step: 'Step',
    of: 'of',
    steps: {
      profile: 'Profile',
      sectors: 'Sectors',
      profileDesc: 'About You',
      terms: 'Terms',
      payment: 'Payment',
    },
    alreadyMember: 'Already a member?',
    login: 'Login',
    
    // Step 1: Personal Info
    step1: {
      requiredFields: 'All fields marked with an asterisk (*) are required',
      errorsFound: 'error(s) found',
      pleaseCorrect: 'Please correct the fields below',
      
      // Profile section
      profileSection: 'Profile',
      firstName: 'First Name *',
      firstNamePlaceholder: 'John',
      lastName: 'Last Name *',
      lastNamePlaceholder: 'Doe',
      email: 'Email *',
      emailPlaceholder: 'john.doe@example.com',
      confirmEmail: 'Confirm Email *',
      password: 'Password *',
      confirmPassword: 'Confirm Password *',
      phone: 'Phone *',
      phonePlaceholder: '+1 (514) 123-4567',
      
      // Address section
      addressSection: 'Address',
      addressSearch: 'Address Search',
      addressSearchPlaceholder: 'Start typing your address...',
      addressSearchHint: 'Select a suggestion to auto-fill the fields below',
      streetAddress: 'Street Address *',
      streetAddressPlaceholder: '123 Main Street, Apt. 4',
      city: 'City *',
      cityPlaceholder: 'Montreal',
      postalCode: 'Postal Code *',
      postalCodePlaceholder: 'H1A 1A1',
      country: 'Country *',
      countryPlaceholder: '— Select a country —',
      province: 'Province/State *',
      provincePlaceholder: '— Select —',
      selectCountryFirst: 'Select a country first',
      
      // Marketing sources
      sourcesSection: 'Marketing Sources',
      sourcesTitle: 'How did you hear about AcquizGroup? *',
      sourcesHint: 'Select all that apply',
      sourcesSelected: 'source(s) selected',
      
      continueButton: 'Continue to Sectors',
    },
    
    // Step 2: Sectors
    step2: {
      hint: 'Add between 1 and 5 business sectors you are interested in',
      sector: 'Sector',
      sectorLabel: 'Business Sector *',
      sectorPlaceholder: '— Select a sector —',
      experienceLabel: 'Years of experience in this sector *',
      experiencePlaceholder: '— Select —',
      year: 'year',
      years: 'years',
      licensesLabel: 'Licenses and Permits (optional)',
      licensesPlaceholder: 'E.g.: Real estate broker license, General contractor permit',
      jurisdictionsCanada: 'Jurisdictions - Canada (optional)',
      jurisdictionsUSA: 'Jurisdictions - USA (optional)',
      holdCtrl: 'Hold Ctrl/Cmd to select multiple',
      addSector: 'Add a sector',
      correctErrors: 'Please correct the errors above before continuing',
      back: 'Back',
      continueButton: 'Continue to Profile',
      documentsLabel: 'Supporting Documents (optional)',
      documentsHint: 'Upload CV, competency cards, awards, or other relevant documents for this sector',
      uploadCV: 'CV / Resume',
      uploadCompetency: 'Competency Card',
      uploadAward: 'Awards / Honors',
      docTypeCV: 'CV',
      docTypeCompetency: 'Competency Card',
      docTypeAward: 'Award',
    },
    
    // Step 3: Profile Description
    step3Profile: {
      hint: 'Complete your profile to stand out to sellers',
      photoTitle: 'Profile Photo',
      uploadPhoto: 'Upload Photo',
      photoHint: 'JPG, PNG. Max 5MB. A professional photo helps build trust.',
      descriptionTitle: 'About You',
      descriptionLabel: 'Describe yourself and what makes you an ideal buyer',
      descriptionPlaceholder: 'Tell sellers about your background, motivations, and what you bring to the table...',
      experienceTitle: 'Your Experience',
      experienceLabel: 'Describe your relevant experience and expertise',
      experiencePlaceholder: 'Share your professional experience, past acquisitions, industry knowledge, management skills...',
      continueButton: 'Continue to Terms',
    },
    
    // Step 4: Terms (renamed from step3)
    step4Terms: {
      acceptError: 'You must accept the Terms and Conditions to continue.',
    },
    
    // Step 3: Terms
    step3: {
      contractTitle: 'SERVICE AND CONFIDENTIALITY AGREEMENT',
      article1Title: 'Article 1. Purpose of the Agreement',
      article1Content: 'AcquizGroup undertakes to provide a matchmaking platform and transaction management tools (MailBox, Data Room, etc.) to the Buyer. The Buyer agrees to use the platform in good faith and in compliance with applicable laws and regulations.',
      article2Title: 'Article 2. Confidentiality',
      article2Content: 'All information and documents shared via the platform are strictly confidential. The Buyer agrees not to disclose or use for purposes other than business acquisition the information obtained about Sellers.',
      article3Title: 'Article 3. Service Fees (BYOD)',
      article3Content: 'Payment covers analysis and activation fees for the Buyer Space for a period of 6 months, as specified in the Pricing section. This amount is non-refundable once the service is activated.',
      article4Title: 'Article 4. Platform Usage',
      article4Content: 'The Buyer has full access to platform features including business search, file analysis, access to the secure Data Room, and communication tools with Sellers and financial partners.',
      article5Title: 'Article 5. Limitation of Liability',
      article5Content: 'AcquizGroup acts as an intermediary and does not guarantee the success of any transaction. The Buyer remains solely responsible for their investment decisions.',
      article6Title: 'Article 6. Applicable Law',
      article6Content: 'This agreement is governed by the laws of Quebec, Canada. Any dispute will be subject to the exclusive jurisdiction of the courts of Quebec.',
      acceptTerms: 'I have read and accept the Terms and Conditions and the Privacy Policy',
      acceptError: 'You must accept the Terms and Conditions to continue.',
      back: 'Back',
      continueButton: 'Proceed to Secure Payment',
    },
    
    // Step 4: Payment
    step4: {
      planTitle: 'BYOD Plan',
      planSubtitle: 'Bring Your Own Deal - Structure your transaction',
      save: 'Save',
      servicesIncluded: 'Services Included (6 months)',
      services: {
        buyerSpace: 'Full access to Buyer Space',
        dataRoom: 'Secure Data Room',
        eLearning: 'E-Learning Platform',
        support: 'Priority support for 6 months',
      },
      payButton: 'Pay',
      securely: 'Securely',
      processing: 'Processing payment...',
      securePayment: '100% secure and encrypted payment',
      backToTerms: 'Back to Terms and Conditions',
      
      // Success
      successTitle: 'Payment Confirmed!',
      successMessage: 'Your payment of',
      successProcessed: 'has been successfully processed.',
      welcomeMessage: 'Welcome to your AcquizGroup Buyer Space!',
      accountActive: 'Your account is now active for 6 months.',
      accessBuyerSpace: 'Access my Buyer Space',
      
      // Failure
      failureTitle: 'Payment Failed',
      failureMessage: 'The payment of',
      failureNotProcessed: 'could not be processed.',
      retryMessage: 'Please check your information and try again.',
      retryButton: 'Retry Payment',
    },
    
    // Validation errors
    errors: {
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email format',
      confirmEmailRequired: 'Please confirm your email',
      emailMismatch: 'Emails do not match',
      passwordRequired: 'Password is required',
      passwordMinLength: 'Minimum 6 characters required',
      confirmPasswordRequired: 'Please confirm password',
      passwordMismatch: 'Passwords do not match',
      phoneRequired: 'Phone is required',
      addressRequired: 'Address is required',
      cityRequired: 'City is required',
      provinceRequired: 'Please select a province/state',
      postalCodeRequired: 'Postal code is required',
      countryRequired: 'Please select a country',
      sourcesRequired: 'Please select at least one source',
      sectorRequired: 'Please select a sector',
      experienceRequired: 'Please select years of experience',
    },
    
    // Countries
    countries: {
      canada: 'Canada',
      usa: 'United States',
    },
    
    // Marketing sources
    sources: {
      facebook: 'Facebook',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      networking: 'Networking Group',
      youtube: 'YouTube',
      google: 'Google Search',
      friends: 'Friends',
      family: 'Family',
      other: 'Other',
    },
    
    // Sectors
    sectors: [
      'ALL SECTORS',
      'AGRICULTURE, AGRI-FOOD & FOOD INDUSTRY',
      'AUTOMOTIVE & BOAT / MARINE',
      'BEAUTY & PERSONAL CARE',
      'RETAIL (General, Sports, Specialized)',
      'COMMUNICATION, MEDIA & PUBLIC RELATIONS',
      'ENGINEERING & TECHNICAL CONSULTING (Civil, Electrical, Chemical, Aero)',
      'CONSTRUCTION & BUILDING (incl. Trades & HVAC)',
      'ENTERTAINMENT, LEISURE & SPORTS',
      'EDUCATION & CHILDCARE SERVICES',
      'ONLINE & TECHNOLOGY (SaaS, Web Dev, IT Services)',
      'SERVICE BUSINESSES (General)',
      'MANUFACTURING & INDUSTRIAL PRODUCTION',
      'ACCOUNTING & TAX FIRM (CPA, CA)',
      'LAW FIRM (Corporate, IP, Real Estate)',
      'WASTE MANAGEMENT, WATER TREATMENT & ENVIRONMENT',
      'WHOLESALERS & DISTRIBUTORS',
      'BUSINESS INTELLIGENCE & DATA CONSULTING',
      'UNCLASSIFIABLE / OTHER',
      'RECRUITMENT & HUMAN RESOURCES',
      'RESTAURANTS & FOOD SERVICES',
      'HOME SERVICES (Residential & Commercial Contractors)',
      'FINANCIAL SERVICES & INSURANCE',
      'REAL ESTATE SERVICES & PROPERTY MANAGEMENT',
      'PET SERVICES',
      'HEALTHCARE, MEDICAL & LIFE SCIENCES',
      'TRANSPORTATION, TRUCKING & LOGISTICS',
      'TRAVEL, TOURISM & HOSPITALITY'
    ],
    
    // Provinces Canada
    provincesCanada: [
      'Alberta (AB)',
      'British Columbia (BC)',
      'Manitoba (MB)',
      'New Brunswick (NB)',
      'Newfoundland and Labrador (NL)',
      'Northwest Territories (NT)',
      'Nova Scotia (NS)',
      'Nunavut (NU)',
      'Ontario (ON)',
      'Prince Edward Island (PE)',
      'Quebec (QC)',
      'Saskatchewan (SK)',
      'Yukon (YT)'
    ],
    
    // States USA
    statesUSA: [
      'Alabama (AL)', 'Alaska (AK)', 'Arizona (AZ)', 'Arkansas (AR)',
      'California (CA)', 'Colorado (CO)', 'Connecticut (CT)', 'Delaware (DE)',
      'Florida (FL)', 'Georgia (GA)', 'Hawaii (HI)', 'Idaho (ID)',
      'Illinois (IL)', 'Indiana (IN)', 'Iowa (IA)', 'Kansas (KS)',
      'Kentucky (KY)', 'Louisiana (LA)', 'Maine (ME)', 'Maryland (MD)',
      'Massachusetts (MA)', 'Michigan (MI)', 'Minnesota (MN)', 'Mississippi (MS)',
      'Missouri (MO)', 'Montana (MT)', 'Nebraska (NE)', 'Nevada (NV)',
      'New Hampshire (NH)', 'New Jersey (NJ)', 'New Mexico (NM)', 'New York (NY)',
      'North Carolina (NC)', 'North Dakota (ND)', 'Ohio (OH)', 'Oklahoma (OK)',
      'Oregon (OR)', 'Pennsylvania (PA)', 'Rhode Island (RI)', 'South Carolina (SC)',
      'South Dakota (SD)', 'Tennessee (TN)', 'Texas (TX)', 'Utah (UT)',
      'Vermont (VT)', 'Virginia (VA)', 'Washington (WA)', 'West Virginia (WV)',
      'Wisconsin (WI)', 'Wyoming (WY)'
    ],
    
    // Jurisdictions
    jurisdictions: {
      canada: {
        all: 'All provinces',
        list: [
          'All provinces',
          'Alberta (AB)',
          'British Columbia (BC)',
          'Manitoba (MB)',
          'New Brunswick (NB)',
          'Newfoundland and Labrador (NL)',
          'Northwest Territories (NT)',
          'Nova Scotia (NS)',
          'Nunavut (NU)',
          'Ontario (ON)',
          'Prince Edward Island (PE)',
          'Quebec (QC)',
          'Saskatchewan (SK)',
          'Yukon (YT)'
        ]
      },
      usa: {
        all: 'All states',
        list: [
          'All states',
          'Alabama (AL)', 'Alaska (AK)', 'Arizona (AZ)', 'Arkansas (AR)',
          'California (CA)', 'Colorado (CO)', 'Connecticut (CT)', 'Delaware (DE)',
          'Florida (FL)', 'Georgia (GA)', 'Hawaii (HI)', 'Idaho (ID)',
          'Illinois (IL)', 'Indiana (IN)', 'Iowa (IA)', 'Kansas (KS)',
          'Kentucky (KY)', 'Louisiana (LA)', 'Maine (ME)', 'Maryland (MD)',
          'Massachusetts (MA)', 'Michigan (MI)', 'Minnesota (MN)', 'Mississippi (MS)',
          'Missouri (MO)', 'Montana (MT)', 'Nebraska (NE)', 'Nevada (NV)',
          'New Hampshire (NH)', 'New Jersey (NJ)', 'New Mexico (NM)', 'New York (NY)',
          'North Carolina (NC)', 'North Dakota (ND)', 'Ohio (OH)', 'Oklahoma (OK)',
          'Oregon (OR)', 'Pennsylvania (PA)', 'Rhode Island (RI)', 'South Carolina (SC)',
          'South Dakota (SD)', 'Tennessee (TN)', 'Texas (TX)', 'Utah (UT)',
          'Vermont (VT)', 'Virginia (VA)', 'Washington (WA)', 'West Virginia (WV)',
          'Wisconsin (WI)', 'Wyoming (WY)'
        ]
      }
    },
  },
  
  fr: {
    pageTitle: 'Inscription Acheteur',
    step: 'Étape',
    of: 'sur',
    steps: {
      profile: 'Profil',
      sectors: 'Secteurs',
      profileDesc: 'À propos',
      terms: 'Termes',
      payment: 'Paiement',
    },
    alreadyMember: 'Déjà membre ?',
    login: 'Connexion',
    
    // Step 1: Personal Info
    step1: {
      requiredFields: 'Tous les champs marqués d\'un astérisque (*) sont obligatoires',
      errorsFound: 'erreur(s) trouvée(s)',
      pleaseCorrect: 'Veuillez corriger les champs ci-dessous',
      
      // Profile section
      profileSection: 'Profil',
      firstName: 'Prénom *',
      firstNamePlaceholder: 'Jean',
      lastName: 'Nom *',
      lastNamePlaceholder: 'Dupont',
      email: 'Email *',
      emailPlaceholder: 'jean.dupont@exemple.com',
      confirmEmail: 'Confirmer l\'email *',
      password: 'Mot de passe *',
      confirmPassword: 'Confirmer le mot de passe *',
      phone: 'Téléphone *',
      phonePlaceholder: '+1 (514) 123-4567',
      
      // Address section
      addressSection: 'Adresse',
      addressSearch: 'Recherche d\'adresse',
      addressSearchPlaceholder: 'Commencez à taper votre adresse...',
      addressSearchHint: 'Sélectionnez une suggestion pour remplir automatiquement les champs ci-dessous',
      streetAddress: 'Adresse de rue *',
      streetAddressPlaceholder: '123 Rue Principale, App. 4',
      city: 'Ville *',
      cityPlaceholder: 'Montréal',
      postalCode: 'Code Postal *',
      postalCodePlaceholder: 'H1A 1A1',
      country: 'Pays *',
      countryPlaceholder: '— Sélectionnez un pays —',
      province: 'États/Provinces *',
      provincePlaceholder: '— Sélectionnez —',
      selectCountryFirst: 'Sélectionnez d\'abord un pays',
      
      // Marketing sources
      sourcesSection: 'Sources Marketing',
      sourcesTitle: 'Comment avez-vous entendu parler d\'AcquizGroup? *',
      sourcesHint: 'Sélectionnez toutes les options applicables',
      sourcesSelected: 'source(s) sélectionnée(s)',
      
      continueButton: 'Continuer vers Secteurs d\'Activité',
    },
    
    // Step 2: Sectors
    step2: {
      hint: 'Ajoutez entre 1 et 5 secteurs d\'activité dans lesquels vous souhaitez rechercher des opportunités',
      sector: 'Secteur',
      sectorLabel: 'Secteur d\'Activité *',
      sectorPlaceholder: '— Sélectionnez un secteur —',
      experienceLabel: 'Années d\'expérience dans ce secteur *',
      experiencePlaceholder: '— Sélectionnez —',
      year: 'an',
      years: 'ans',
      licensesLabel: 'Licences et Permis (optionnel)',
      licensesPlaceholder: 'Ex: Licence de courtier immobilier, Permis entrepreneur général',
      jurisdictionsCanada: 'Juridictions - Canada (optionnel)',
      jurisdictionsUSA: 'Juridictions - États-Unis (optionnel)',
      holdCtrl: 'Maintenez Ctrl/Cmd pour sélectionner plusieurs',
      addSector: 'Ajouter un secteur',
      correctErrors: 'Veuillez corriger les erreurs ci-dessus avant de continuer',
      back: 'Retour',
      continueButton: 'Continuer vers Profil',
      documentsLabel: 'Documents justificatifs (optionnel)',
      documentsHint: 'Téléversez CV, cartes de compétence, prix honorifiques ou autres documents pertinents pour ce secteur',
      uploadCV: 'CV / Curriculum',
      uploadCompetency: 'Carte de compétence',
      uploadAward: 'Prix / Distinctions',
      docTypeCV: 'CV',
      docTypeCompetency: 'Carte de compétence',
      docTypeAward: 'Prix',
    },
    
    // Step 3: Profile Description
    step3Profile: {
      hint: 'Complétez votre profil pour vous démarquer auprès des vendeurs',
      photoTitle: 'Photo de profil',
      uploadPhoto: 'Téléverser une photo',
      photoHint: 'JPG, PNG. Max 5Mo. Une photo professionnelle aide à établir la confiance.',
      descriptionTitle: 'À propos de vous',
      descriptionLabel: 'Décrivez-vous et ce qui fait de vous l\'acheteur idéal',
      descriptionPlaceholder: 'Parlez aux vendeurs de votre parcours, motivations et ce que vous apportez...',
      experienceTitle: 'Votre expérience',
      experienceLabel: 'Décrivez votre expérience et expertise pertinentes',
      experiencePlaceholder: 'Partagez votre expérience professionnelle, acquisitions passées, connaissances sectorielles, compétences en gestion...',
      continueButton: 'Continuer vers Termes',
    },
    
    // Step 4: Terms
    step4Terms: {
      acceptError: 'Vous devez accepter les Termes et Conditions pour continuer.',
    },
    
    // Step 3: Terms
    step3: {
      contractTitle: 'CONTRAT DE SERVICE ET CONFIDENTIALITÉ',
      article1Title: 'Article 1. Objet du Contrat',
      article1Content: 'AcquizGroup s\'engage à fournir une plateforme de \'matchmaking\' et des outils de gestion de transaction (MailBox, Data Room, etc.) à l\'Acheteur. L\'Acheteur s\'engage à utiliser la plateforme en toute bonne foi et conformément aux lois et règlements en vigueur.',
      article2Title: 'Article 2. Confidentialité',
      article2Content: 'Toutes les informations et les documents partagés via la plateforme sont strictement confidentiels. L\'Acheteur s\'engage à ne pas divulguer, ni utiliser à d\'autres fins que l\'acquisition d\'entreprise, les informations obtenues sur les Vendeurs.',
      article3Title: 'Article 3. Frais de Service (BYOD)',
      article3Content: 'Le paiement couvre les frais d\'analyse et d\'activation de l\'Espace Acheteur pour une durée de 6 mois, comme spécifié dans la section Tarification. Ce montant est non remboursable une fois le service activé.',
      article4Title: 'Article 4. Utilisation de la Plateforme',
      article4Content: 'L\'Acheteur bénéficie d\'un accès complet aux fonctionnalités de la plateforme incluant la recherche d\'entreprises, l\'analyse de dossiers, l\'accès à la Data Room sécurisée, et les outils de communication avec les Vendeurs et partenaires financiers.',
      article5Title: 'Article 5. Limitation de Responsabilité',
      article5Content: 'AcquizGroup agit en tant qu\'intermédiaire et ne garantit pas la réussite d\'une transaction. L\'Acheteur demeure seul responsable de ses décisions d\'investissement.',
      article6Title: 'Article 6. Loi Applicable',
      article6Content: 'Ce contrat est régi par les lois du Québec, Canada. Tout litige sera soumis à la juridiction exclusive des tribunaux du Québec.',
      acceptTerms: 'J\'ai lu et j\'accepte les Termes et Conditions ainsi que la Politique de Confidentialité',
      acceptError: 'Vous devez accepter les Termes et Conditions pour continuer.',
      back: 'Retour',
      continueButton: 'Procéder au Paiement Sécurisé',
    },
    
    // Step 4: Payment
    step4: {
      planTitle: 'Forfait BYOD',
      planSubtitle: 'Bring Your Own Deal - Structurez votre transaction',
      save: 'Économisez',
      servicesIncluded: 'Services Inclus (6 mois)',
      services: {
        buyerSpace: 'Accès complet à l\'Espace Acheteur',
        dataRoom: 'Data Room sécurisée',
        eLearning: 'Plateforme E-Learning',
        support: 'Support prioritaire 6 mois',
      },
      payButton: 'Payer',
      securely: 'en Toute Sécurité',
      processing: 'Traitement du paiement...',
      securePayment: 'Paiement 100% sécurisé et crypté',
      backToTerms: 'Revenir aux Termes et Conditions',
      
      // Success
      successTitle: 'Paiement Confirmé !',
      successMessage: 'Votre paiement de',
      successProcessed: 'a été traité avec succès.',
      welcomeMessage: 'Bienvenue dans votre Espace Acheteur AcquizGroup !',
      accountActive: 'Votre compte est maintenant actif pour 6 mois.',
      accessBuyerSpace: 'Accéder à mon Espace Acheteur',
      
      // Failure
      failureTitle: 'Échec du Paiement',
      failureMessage: 'Le paiement de',
      failureNotProcessed: 'n\'a pas pu être traité.',
      retryMessage: 'Veuillez vérifier vos informations et réessayer.',
      retryButton: 'Réessayer le Paiement',
    },
    
    // Validation errors
    errors: {
      firstNameRequired: 'Le prénom est obligatoire',
      lastNameRequired: 'Le nom est obligatoire',
      emailRequired: 'L\'email est obligatoire',
      emailInvalid: 'Format d\'email invalide',
      confirmEmailRequired: 'Confirmez votre email',
      emailMismatch: 'Les emails ne correspondent pas',
      passwordRequired: 'Le mot de passe est obligatoire',
      passwordMinLength: 'Minimum 6 caractères requis',
      confirmPasswordRequired: 'Confirmez le mot de passe',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      phoneRequired: 'Le téléphone est obligatoire',
      addressRequired: 'L\'adresse est obligatoire',
      cityRequired: 'La ville est obligatoire',
      provinceRequired: 'Sélectionnez une province/état',
      postalCodeRequired: 'Le code postal est obligatoire',
      countryRequired: 'Sélectionnez un pays',
      sourcesRequired: 'Sélectionnez au moins une source',
      sectorRequired: 'Sélectionnez un secteur',
      experienceRequired: 'Sélectionnez les années d\'expérience',
    },
    
    // Countries
    countries: {
      canada: 'Canada',
      usa: 'États-Unis',
    },
    
    // Marketing sources
    sources: {
      facebook: 'Facebook',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      networking: 'Groupe de réseautage',
      youtube: 'Youtube',
      google: 'Recherches Google',
      friends: 'Amis',
      family: 'Famille',
      other: 'Autre',
    },
    
    // Sectors
    sectors: [
      'TOUS LES SECTEURS',
      'AGRICULTURE, AGRO-ALIMENTAIRE & INDUSTRIE ALIMENTAIRE',
      'AUTOMOBILE & BATEAU / MARINE',
      'BEAUTÉ & SOINS PERSONNELS',
      'COMMERCE DE DÉTAIL (Général, Sport, Spécialisé)',
      'COMMUNICATION, MÉDIAS & RELATIONS PUBLIQUES',
      'CONSEIL EN GÉNIE & TECHNIQUE (Civil, Électrique, Chimique, Aéro)',
      'CONSTRUCTION & BÂTIMENT (incl. Métiers & CVC)',
      'DIVERTISSEMENT, LOISIRS & SPORT',
      'ÉDUCATION & SERVICES AUX ENFANTS',
      'EN LIGNE & TECHNOLOGIE (SaaS, Dév. Web, Services TI)',
      'ENTREPRISES DE SERVICES (Général)',
      'FABRICATION & PRODUCTION INDUSTRIELLE',
      'FIRME COMPTABLE & FISCALE (CPA, CA)',
      'FIRME JURIDIQUE (Corporatif, PI, Immobilier)',
      'GESTION DES DÉCHETS, TRAITEMENT DE L\'EAU & ENVIRONNEMENT',
      'GROSSISTES & DISTRIBUTEURS',
      'INTELLIGENCE D\'AFFAIRES & CONSEIL EN DONNÉES',
      'NON CLASSIFIABLE / AUTRE',
      'RECRUTEMENT & RESSOURCES HUMAINES',
      'RESTAURANTS & SERVICES ALIMENTAIRES',
      'SERVICES À DOMICILE (Contracteurs Résidentiels & Commerciaux)',
      'SERVICES FINANCIERS & ASSURANCE',
      'SERVICES IMMOBILIERS & GESTION DE PROPRIÉTÉS',
      'SERVICES POUR ANIMAUX',
      'SOINS DE SANTÉ, MÉDICAL & SCIENCES DE LA VIE',
      'TRANSPORT, CAMIONNAGE & LOGISTIQUE',
      'VOYAGE, TOURISME & HÔTELLERIE'
    ],
    
    // Provinces Canada
    provincesCanada: [
      'Alberta (AB)',
      'Colombie-Britannique (BC)',
      'Manitoba (MB)',
      'Nouveau-Brunswick (NB)',
      'Terre-Neuve-et-Labrador (NL)',
      'Territoires du Nord-Ouest (NT)',
      'Nouvelle-Écosse (NS)',
      'Nunavut (NU)',
      'Ontario (ON)',
      'Île-du-Prince-Édouard (PE)',
      'Québec (QC)',
      'Saskatchewan (SK)',
      'Yukon (YT)'
    ],
    
    // States USA
    statesUSA: [
      'Alabama (AL)', 'Alaska (AK)', 'Arizona (AZ)', 'Arkansas (AR)',
      'Californie (CA)', 'Colorado (CO)', 'Connecticut (CT)', 'Delaware (DE)',
      'Floride (FL)', 'Géorgie (GA)', 'Hawaï (HI)', 'Idaho (ID)',
      'Illinois (IL)', 'Indiana (IN)', 'Iowa (IA)', 'Kansas (KS)',
      'Kentucky (KY)', 'Louisiane (LA)', 'Maine (ME)', 'Maryland (MD)',
      'Massachusetts (MA)', 'Michigan (MI)', 'Minnesota (MN)', 'Mississippi (MS)',
      'Missouri (MO)', 'Montana (MT)', 'Nebraska (NE)', 'Nevada (NV)',
      'New Hampshire (NH)', 'New Jersey (NJ)', 'Nouveau-Mexique (NM)', 'New York (NY)',
      'Caroline du Nord (NC)', 'Dakota du Nord (ND)', 'Ohio (OH)', 'Oklahoma (OK)',
      'Oregon (OR)', 'Pennsylvanie (PA)', 'Rhode Island (RI)', 'Caroline du Sud (SC)',
      'Dakota du Sud (SD)', 'Tennessee (TN)', 'Texas (TX)', 'Utah (UT)',
      'Vermont (VT)', 'Virginie (VA)', 'Washington (WA)', 'Virginie-Occidentale (WV)',
      'Wisconsin (WI)', 'Wyoming (WY)'
    ],
    
    // Jurisdictions
    jurisdictions: {
      canada: {
        all: 'Toutes les provinces',
        list: [
          'Toutes les provinces',
          'Alberta (AB)',
          'Colombie-Britannique (BC)',
          'Manitoba (MB)',
          'Nouveau-Brunswick (NB)',
          'Terre-Neuve-et-Labrador (NL)',
          'Territoires du Nord-Ouest (NT)',
          'Nouvelle-Écosse (NS)',
          'Nunavut (NU)',
          'Ontario (ON)',
          'Île-du-Prince-Édouard (PE)',
          'Québec (QC)',
          'Saskatchewan (SK)',
          'Yukon (YT)'
        ]
      },
      usa: {
        all: 'Tous les états',
        list: [
          'Tous les états',
          'Alabama (AL)', 'Alaska (AK)', 'Arizona (AZ)', 'Arkansas (AR)',
          'Californie (CA)', 'Colorado (CO)', 'Connecticut (CT)', 'Delaware (DE)',
          'Floride (FL)', 'Géorgie (GA)', 'Hawaï (HI)', 'Idaho (ID)',
          'Illinois (IL)', 'Indiana (IN)', 'Iowa (IA)', 'Kansas (KS)',
          'Kentucky (KY)', 'Louisiane (LA)', 'Maine (ME)', 'Maryland (MD)',
          'Massachusetts (MA)', 'Michigan (MI)', 'Minnesota (MN)', 'Mississippi (MS)',
          'Missouri (MO)', 'Montana (MT)', 'Nebraska (NE)', 'Nevada (NV)',
          'New Hampshire (NH)', 'New Jersey (NJ)', 'Nouveau-Mexique (NM)', 'New York (NY)',
          'Caroline du Nord (NC)', 'Dakota du Nord (ND)', 'Ohio (OH)', 'Oklahoma (OK)',
          'Oregon (OR)', 'Pennsylvanie (PA)', 'Rhode Island (RI)', 'Caroline du Sud (SC)',
          'Dakota du Sud (SD)', 'Tennessee (TN)', 'Texas (TX)', 'Utah (UT)',
          'Vermont (VT)', 'Virginie (VA)', 'Washington (WA)', 'Virginie-Occidentale (WV)',
          'Wisconsin (WI)', 'Wyoming (WY)'
        ]
      }
    },
  },
};

export type BuyerTranslations = typeof BUYER_TRANSLATIONS.en;
